import { Fragment } from 'react';
import { Link, matchPath, generatePath, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { BinIcon } from '../../components/Icon/Icon';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import { MENU_ITEMS } from './menuConstants.js';
import { MenuStyled } from './styled/MenuStyled';

function Menu() {
    const { getLangPath } = useLangContext();
    const location = useLocation();

    return (
        <MenuStyled>
            {MENU_ITEMS.map((item) => {
                const isActive = !!matchPath(location.pathname, {
                    path: item.path,
                    exact: item.exact ?? true,
                });

                return (
                    <Fragment key={item.name}>
                        <Link
                            to={generatePath(item.path)}
                            className={classNames('item', { active: isActive })}
                        >
                            <BinIcon name={item.icon} size="16px" />
                            {getLangPath(`menu.${item.name}`)}
                        </Link>
                    </Fragment>
                );
            })}
        </MenuStyled>
    );
}

export default Menu;
